import gql from 'graphql-tag';

export const GRAPHQL_MUTATION_UPDATE_MERCHANT = gql`
  mutation updateMerchant($userInput: UpdateUserInput!, $merchantInput: UpdateMerchantInput!) {
    updateMerchant(userInput: $userInput, merchantInput: $merchantInput) {
      id
      firstName
      lastName
      isActive
      isDeleted
      email
      postalCode
      street
      postalCode
      city
      merchant{
        id
        totalAvailableNotification
        businessName
        contactEmail
        phoneNumber
        siret
        salesArea
        type
        intraVatNumber
        createdAt
        updatedAt
        brand{
          id
          name
        }
      }
    }
  }
`;

export const GRAPHQL_QUERY_MERCHANTS = gql`
  query merchants($criteria: CriteriaInput!) {
    merchants(criteria: $criteria) {
      rows {
        businessName
        contactEmail
        phoneNumber
        siret
        salesArea
        type
        intraVatNumber
        createdAt
        updatedAt
        totalAvailableNotification
        id
        brand{
          id
          name
        }
        user{
          id
          firstName
          lastName
          isActive
          isDeleted
          street
          postalCode
          city
          hasActiveSubscription
        }
      }
      total
      id
    }
  }
`;

export const GRAPHQL_MUTATION_REGISTER_MERCHANT = gql`
  mutation registerMerchant($userInput: RegisterUserInput!, $merchantInput: RegisterMerchantInput!, $numberCheckoutToCreate: Int) {
    registerMerchant(userInput: $userInput, merchantInput: $merchantInput, numberCheckoutToCreate: $numberCheckoutToCreate) {
      id
      firstName
      lastName
      isActive
      isDeleted
      street
      postalCode
      city
      merchant{
        id
        businessName
        contactEmail
        phoneNumber
        siret
        salesArea
        type
        intraVatNumber
        createdAt
        updatedAt
        brand{
          id
          name
        }
      }
    }
  }
`;
